import { useTranslation } from "react-i18next";
import CostRefundReviewModal from "features/hr/costRefund/components/CostRefundReviewModal";
import { canBeAccepted, canBeCorrected, canBeDeleted, canBeMarkedAsIncomplete, getBackgroundStyle, getStatusIcon, getStatusLabel } from "features/hr/costRefund/components/CostRefundLogic";
import Modal from "components/commons/Modal";
import { NavLink } from "react-router-dom";
import UserImage from "components/commons/UserImage";
import { useSelector } from "react-redux";
import { selectCompanyGuid } from "features/auth/authSlice";
import { Galleria } from "primereact/galleria";

export default function CostRefundView({
    refund,
    administrable = false,
    onAccept,
    onDelete
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const companyGuid = useSelector(selectCompanyGuid)

    const apiUrl = process.env.REACT_APP_API_URL

    let startDate = new Date(refund.startDate * 1000)
    let endDate = new Date(refund.endDate * 1000)

    let days = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24) + 1);

    function hasDistance() {
        return refund.distance != null && refund.distance > 0
    }

    function hasExpenses() {
        return refund.totalExpense > 0
    }

    function hasAttachments() {
        return refund.attachments.length > 0
    }


    return (<>

        <div className={`card text-white h-100 bg-dark bg-opacity-25`}>
            <div className={`card-header ${getBackgroundStyle(refund)}`}>
                <div>
                    <CostRefundStatus refund={refund} />
                </div>
                <div className='row my-3'>
                    <div className='col-6'>

                        <h3>{refund.title}</h3>
                    </div>
                </div>

                {
                    refund.user &&
                    <div className='row my-3'>
                        <div className='col-6'>
                            {/* <img className="rounded-circle me-2" width="48px" src={`https://ui-avatars.com/api/?name=${refund.user.displayName.replace(" ", "+")}&background=random`} /> */}
                            <UserImage guid={refund.user.guid} />
                            <span className='ms-2'>{refund.user ? refund.user.displayName : "La mia nota spesa"}</span>

                        </div>
                    </div>
                }

            </div>
            <div className="card-body bg-black bg-opacity-10">

                <div className='row p-2 mb-3'>
                    {refund.isKmMode &&
                        <div className="col-auto">
                            <input readOnly className="form-check-input" type="checkbox" id="kmMode" name="kmMode" checked={refund.isKmMode} /> <label htmlFor="kmMode"> {t("absenceReport:entity.costRefund.type.distance")}</label>
                        </div>
                    }
                    {
                        refund.isForfaitMode &&
                        <div className="col-auto">
                            <input readOnly className="form-check-input" type="checkbox" id="forfaitMode" name="forfaitMode" checked={refund.isForfaitMode} /> <label htmlFor="forfaitMode"> {t("absenceReport:entity.costRefund.type.forfait")}</label>
                        </div>
                    }
                    {
                        refund.isAnalyticMode &&
                        <div className="col-auto">
                            <input readOnly className="form-check-input" type="checkbox" id="analyticMode" name="analyticMode" checked={refund.isAnalyticMode} /> <label htmlFor="analyticMode"> {t("absenceReport:entity.costRefund.type.analytic")}</label>
                        </div>
                    }


                </div>

                <div className='row p-2 mb-3'>
                    <div className="col-auto">
                        <h5><i className="fa-solid fa-calendar-days text-muted"></i> {days} {t("global:unit.days", { count: days })}</h5>
                    </div>
                    <div className="col-auto">
                        <small className='text-muted ms-2'>
                            <>{t("particles.from")} {new Date(refund.startDate * 1000).toLocaleDateString()} {t("particles.to")} {new Date(refund.endDate * 1000).toLocaleDateString()}</>
                        </small>
                    </div>
                </div>

                {
                    hasDistance() &&
                    <div className='row p-2 mb-3'>
                        <div className="col"><h5><i className={`fa-solid fa-road text-muted `}></i> {refund.distance} km</h5></div>

                    </div>
                }

                {
                    hasExpenses() &&
                    <div className="row p-2 mb-3">
                        <h5>Voci di spesa</h5>
                        <div className='col mt-3 p-2 bg-black bg-opacity-25'>
                            {
                                refund.expenseItems.map((item, index) => {

                                    return <div key={index} className="row">
                                        <div className="col text-muted">
                                            {item.name}
                                        </div>
                                        <div className="col text-end text-muted">
                                            {item.import.toFixed(2)}
                                        </div>
                                    </div>
                                })
                            }
                            <hr />
                            <div className="row">
                                <div className="col">
                                    <b>{t("unit.total")}</b>
                                </div>
                                <div className="col text-end">
                                    <h4><span className='text-muted'>€</span> {refund.totalExpense.toFixed(2)}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className='row p-2'>
                    <div className='col-auto'>
                        <h5>Note</h5>
                        {refund.notes ?? <span className="text-muted">N/A</span>}
                    </div>
                </div>

                {
                    hasAttachments() &&
                    <AttachmentsSection attachments={refund.attachments} apiUrl={apiUrl} />
                }



            </div>
            <div className="card-footer">
                {
                    administrable && canBeDeleted(refund) &&
                    <Modal
                        modalId={"deletetModal" + refund.guid}
                        buttonClass="btn-outline-danger mx-2"
                        buttonLabel={t("action.delete")}
                        buttonIcon={<i className="fa-solid fa-trash"></i>}
                        body={t("absenceReport:helper.confirm_delete")}
                        onConfirm={() => onDelete(refund.guid)}
                    />
                }
                {
                    administrable && canBeMarkedAsIncomplete(refund) &&
                    <CostRefundReviewModal refundGuid={refund.guid} />
                }
                {
                    !administrable && canBeCorrected(refund) &&
                    <NavLink to={{ pathname: "/dashboard/costRefunds/my/edit" }} state={{ costRefund: refund }} className="btn btn-warning"><i className="fa-solid fa-triangle-exclamation fa-beat"></i> {t("action.adjust")}</NavLink>
                }
                {
                    administrable && canBeAccepted(refund) &&
                    <Modal
                        modalId={"acceptModal" + refund.guid}
                        buttonClass="btn-success mx-2"
                        buttonLabel={t("action.accept")}
                        buttonIcon={<i className="fa-solid fa-circle-check fa-beat"></i>}
                        body={t("absenceReport:helper.confirm_accept")}
                        onConfirm={() => onAccept(refund.guid)}
                    />
                }
            </div>
        </div >
    </>)
}

const IMAGE_EXTENSIONS = new Set(["jpg","jpeg","png","gif","webp","bmp","tiff","tif","svg","avif","heic","heif"]);

function AttachmentsSection({ attachments, apiUrl }) {
    const pdfs = attachments.filter(a => a.split(".").at(-1).toLowerCase() === "pdf");
    const images = attachments.filter(a => IMAGE_EXTENSIONS.has(a.split(".").at(-1).toLowerCase()));

    return (
        <div className="row p-2 mt-3">
            <h5>
                <i className="fa-solid fa-paperclip me-2 text-muted" />
                Allegati
                <span className="badge bg-secondary ms-2">{attachments.length}</span>
            </h5>

            {pdfs.length > 0 && (
                <div className="mt-2">
                    <small className="text-muted text-uppercase fw-bold">PDF</small>
                    <div className="mt-1">
                        {pdfs.map(fileName => (
                            <a
                                key={fileName}
                                href={`${apiUrl}/file?file=${fileName}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-secondary me-2 mb-2"
                            >
                                <i className="fa-solid fa-file-pdf me-1" />
                                {fileName.split("/").at(-1)}
                            </a>
                        ))}
                    </div>
                </div>
            )}

            {images.length > 0 && (
                <div className="mt-2">
                    <small className="text-muted text-uppercase fw-bold">Immagini</small>
                    <div className="mt-1">
                        <Galleria
                            value={images.map(fileName => `${apiUrl}/file?file=${fileName}`)}
                            responsiveOptions={[
                                { breakpoint: '991px', numVisible: 4 },
                                { breakpoint: '767px', numVisible: 3 },
                                { breakpoint: '575px', numVisible: 1 },
                            ]}
                            numVisible={5}
                            style={{ maxWidth: '100%' }}
                            item={(item) => <img src={item} alt={item} style={{ width: '100%' }} />}
                            thumbnail={(item) => <img src={item} alt={item} style={{ width: '100px' }} />}
                            showItemNavigators
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

function CostRefundStatus({ refund }) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    function getColor() {
        switch (refund.status) {
            case "SENT": return "bg-dark"
            case "ACCEPTED": return "bg-success"
            case "INCOMPLETE": return "bg-warning bg-opacity-75"
            case "UPDATED": return "bg-primary"
            case "CANCELED": return "bg-dark"
            case "DELETED": return "bg-danger"
            default: return "bg-dark"
        }
    }

    return <div className="row">
        <div className="col">
            <div className={`badge rounded-pill  ${getColor()}`}><h6 className="m-1">{getStatusIcon(refund)} {getStatusLabel(refund, t).toUpperCase()} </h6> </div> <small className="px-2"> {new Date(refund.lastEditAt).toLocaleString([], { dateStyle: "short", timeStyle: 'short' })}</small>
        </div>
        <div className="col text-end">
            <small className="text-muted">{t("property.created_at")} {new Date(refund.createdDate).toLocaleString([], { dateStyle: "short", timeStyle: 'short' })}</small>
        </div>

    </div>

}
